import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <Link
              to="/"
              className="text-3xl font-heading font-bold text-background-50 tracking-tight"
            >
              Hipobuy
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed max-w-xs">
              Hipobuy Spreadsheet est l&apos;outil de gestion de données nouvelle génération,
              conçu pour les professionnels du e-commerce européen. Automatisation, analyse et
              productivité réunies dans une interface moderne.
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer"
                aria-label="Kaspreadsheet"
              >
                <i className="ri-external-link-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer"
                aria-label="Produits"
              >
                <i className="ri-store-2-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer"
                aria-label="Contact"
              >
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col gap-6">
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-4">Navigation</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">Accueil</Link>
                <Link to="/article/hipobuy-spreadsheet-guide-complet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">Guide SEO Hipobuy Spreadsheet</Link>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">Kaspreadsheet</a>
              </div>
            </div>
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-4">Catégories Populaires</h4>
              <div className="flex flex-wrap gap-2">
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-300 hover:text-background-50 px-3 py-1.5 rounded-full border border-foreground-800 transition-colors whitespace-nowrap">Shoes</a>
                <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-300 hover:text-background-50 px-3 py-1.5 rounded-full border border-foreground-800 transition-colors whitespace-nowrap">T-Shirts</a>
                <a href="https://kaspreadsheet.com/category-914-Jackets.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-300 hover:text-background-50 px-3 py-1.5 rounded-full border border-foreground-800 transition-colors whitespace-nowrap">Jackets</a>
                <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-300 hover:text-background-50 px-3 py-1.5 rounded-full border border-foreground-800 transition-colors whitespace-nowrap">Hoodies</a>
                <a href="https://kaspreadsheet.com/category-921-Bags.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-300 hover:text-background-50 px-3 py-1.5 rounded-full border border-foreground-800 transition-colors whitespace-nowrap">Bags</a>
                <a href="https://kaspreadsheet.com/category-920-Accessories.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-300 hover:text-background-50 px-3 py-1.5 rounded-full border border-foreground-800 transition-colors whitespace-nowrap">Accessories</a>
              </div>
            </div>
          </div>

          {/* CTA Column */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-4">Hipobuy Spreadsheet</h4>
            <p className="text-sm text-foreground-300 leading-relaxed mb-5">
              Découvrez la puissance de Hipobuy Spreadsheet, l&apos;alternative intelligente
              aux tableurs traditionnels. Boostez votre productivité dès aujourd&apos;hui.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              hipobuy spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-800">
        <div className="w-full max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 Hipobuy Spreadsheet. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">Accueil</Link>
            <Link to="/article/hipobuy-spreadsheet-guide-complet" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">Guide SEO</Link>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">Kaspreadsheet</a>
          </div>
        </div>
      </div>
    </footer>
  );
}